import { trans } from '../app';

export const planValidation = {
  name: [
    v => !!v || trans('validation.required', { 'attribute': trans('app.name') }),
    v => v && v.length <= 255 || trans('validation.max.string', {
      attribute: trans('app.name'),
      max: 255,
    }),
    v => v && v.length >= 3 || trans('validation.min.string', {
      attribute: trans('app.name'),
      min: 3,
    }),
  ],
  time: [
    v => !!v || trans('validation.required', { 'attribute': trans('app.hour') }),
    v => /([01]\d|2[0-3]):[0-5]\d/.test(v) || trans('validation.regex', {
      attribute: trans('app.hour'),
    }),
  ],
  energy_percentage: [
      v => !!v || trans('validation.required', { 'attribute': trans('app.energy_percentage')})
  ],
  energy: [
      v => !!v || trans('validation.required', { 'attribute': trans('app.energy')}),
  ]

};
